module.exports = import("https://cdn.jsdelivr.net/npm/@n8n/chat/dist/chat.bundle.es.js");;